<template>
    <div>
        <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="lbl.ultimateService.title.default" small logo sideMenu></TopBarBg>
        <PageContent class="flex-auto" :hasPoweredBy="hasPoweredBy">
            <div class="my-6 mx-18px">
                <UltimateServiceList :modalController="modalController" @onLoaded="onLoaded()"></UltimateServiceList>
            </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
    </div>
</template>

<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import UltimateServiceList from '@/module/UltimateService/component/UltimateServiceList.vue'
import ModalMaster from "@/components/Modal/ModalMaster.vue"

// mixins
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"
import PdpaMixin from "@/mixin/PdpaMixin";
export default {
    name: 'UtimateService',
    components: {
        TopBarBg,
        PageContent,
        Footer,
        UltimateServiceList,
        ModalMaster
    },
    computed:{
        hasPoweredBy: function(){
            return false
        }
    },
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, PdpaMixin],
    emits: [],
    mounted: function () {
        this.loadingModal.show()
    },
    methods: {
        onLoaded: function(){
            this.loadingModal.hide()
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
